import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  dataListHotel: {},
  isInventoryList: 0,
  services: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
